import React, { ReactNode } from 'react';

// Material ui
import { Snackbar as MaterialSnackbar, Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import Button from '@components/UI-KIT/Button';
import IconButton from '@components/UI-KIT/IconButton';

// Styles
import './Snackbar.scss';
import VARIABLES from '@/assets/variables.ts';
import { Close } from '@/assets/icons';

interface Props {
    icon?: ReactNode;
    message: string | ReactNode;
    color?: 'success' | 'error' | 'neutral';
    action?: {
        label: string;
        handler: () => void;
        icon: ReactNode;
    };
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Snackbar: React.FC<Props> = ({
    icon,
    message,
    color = 'neutral',
    action,
    open,
    setOpen
}) => {
    const handleColors = () => {
        switch (color) {
        case 'success':
            return VARIABLES.palette.success_color;
        case 'error':
            return VARIABLES.palette.error_color;
        default:
            return VARIABLES.palette.content_color;
        }
    };

    return (
        <>
            <MaterialSnackbar
                style={{
                    backgroundColor: handleColors()
                }}
                open={open}
                classes={{
                    root: 'ui-Snackbar-component'
                }}
                anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'bottom'
                }}
            >
                <Grid
                    container
                    justify="space-between"
                    wrap="nowrap"
                    alignItems="center"
                    className="ui-Snackbar-container"
                >
                    <Grid
                        item
                        container
                        justify="flex-start"
                        alignItems="center"
                        className="ui-Snackbar-message-container"
                        wrap="nowrap"
                    >
                        {icon && icon}
                        { typeof message === 'string' ? (
                            <Typography
                                variant="table-regular"
                                color="white"
                            >
                                {message}
                            </Typography>
                        ) : message }
                    </Grid>
                    <Grid
                        item
                        container
                        justify="flex-end"
                        alignItems="center"
                        className="ui-Snackbar-button-container"
                    >
                        { action ? (
                            <Button
                                level={4}
                                className="ui-Snackbar-action-button"
                                label={action.label}
                                icon={action.icon}
                                onClick={action.handler}
                            />
                        ) : (
                            <IconButton
                                className="ui-Snackbar-action-button"
                                onClick={() => setOpen(false)}
                            >
                                <Close
                                    color="white"
                                />
                            </IconButton>
                        )}
                    </Grid>
                </Grid>
            </MaterialSnackbar>
        </>
    );
};

export default Snackbar;
